export default __webpack_public_path__ + "static/AppMoneyWalkie8-a74c11728fa7a13962bd868cdf48be66.png";